import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { bool, number } from 'prop-types';
import * as R from 'ramda';

const informationBoxProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '80px',
  justifyContent: 'space-between',
  pb: 1.5,
  textAlign: 'center',
  width: '47%',
};

const loadingAllowedBox = loadingAllowed => ({
  alignItems: 'center',
  bgcolor: loadingAllowed ? 'success.light' : 'error.light',
  borderRadius: 0.5,
  color: loadingAllowed ? 'text.primary' : 'error.dark',
  display: 'flex',
  height: 48,
  justifyContent: 'center',
  mb: 2,
});

const CardBody = ({ loadingAllowed, notSequencedCount, sequencedCount }) => (
  <>
    <Box display="flex" justifyContent="space-between">
      <Box {...informationBoxProperties}>
        <Divider />
        <Typography variant="body2">Sequenced</Typography>
        <Typography variant="h5">{R.defaultTo('--', sequencedCount)}</Typography>
      </Box>
      <Box {...informationBoxProperties}>
        <Divider />
        <Typography variant="body2">Not Sequenced</Typography>
        <Typography variant="h5">{R.defaultTo('--', notSequencedCount)}</Typography>
      </Box>
    </Box>
    <Box {...loadingAllowedBox(loadingAllowed)}>
      <Typography color="inherit" variant="subtitle1">{`Loading${
        loadingAllowed ? ' ' : ' Not '
      }Allowed`}</Typography>
    </Box>
  </>
);

CardBody.propTypes = {
  loadingAllowed: bool.isRequired,
  notSequencedCount: number,
  sequencedCount: number,
};

CardBody.defaultProps = {
  notSequencedCount: undefined,
  sequencedCount: undefined,
};

export default CardBody;
